import { log } from 'log';

export const logRunTag = (tagName, tagType, config) => {
    log('groupCollapsed', `Tag manager | Trigger tag: ${tagName}`);
    log('log', 'TYPE:', tagType);
    log('log', 'CONFIG:', config);
    log('groupEnd');
};
